import { Stack, Typography, useMediaQuery, useTheme } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import BootstrapTooltip from '@/components/base/BootstrapTooltip'
import { useState } from 'react'

const IneligibleLCRatio = () => {
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.up('sm'))
  const [iconColor, setIconColor] = useState('#FFFFFF7A')

  const handleIconClick = () => {
    if (!isSmall) {
      // Change icon color when clicked
      setIconColor('#FAFAFA')

      // Revert the color after 2 seconds
      setTimeout(() => {
        setIconColor('#FFFFFF7A')
      }, 1600)
    }
  }
  return (
    <Stack direction="row" justifyContent="space-between" className="py-1.5 lg:py-2">
      <Typography className="text-white/50 text-xs-2 sm:text-sm font-dm_mono_regular">LC ratio</Typography>
      <Stack direction="row" className="flex items-center gap-1">
        <Typography className="text-light-orange font-dm_mono_regular text-xs-2 sm:text-sm">Ineligible</Typography>
        <BootstrapTooltip
          title="Launchpad Credit (LC) is exclusively earned through SOLCAT staking"
          placement="top"
          className="font-dm_mono_regular"
          leaveDelay={isSmall ? 0 : 2000}
        >
          <HelpOutlineIcon
            sx={{
              color: iconColor,
              width: 24,
              height: 24,
              '&:hover': {
                color: { sm: '#DCC1FF' },
              },
            }}
            className="cursor-pointer"
            onClick={handleIconClick}
          />
        </BootstrapTooltip>
      </Stack>
    </Stack>
  )
}

export default IneligibleLCRatio
